import * as constants from './constants';
import { initialState } from './states';

/**
 * reducer
 */
export default (state = initialState, action) => {
    switch (action.type) {
        case constants.CHANGE_CONTENT_LOADING:
            return {
                ...state,
                contentLoading: action.data
            };
        case constants.CHANGE_CONTENT_PADDINGBOTTOM:
            return {
                ...state,
                contentPaddingBottom: action.data
            };
        default:
            break;
    }
    return state;
};
